<template>
  <b-modal
    id="export-to-layout-modal"
    title="Export to Layout"
    size="lg"
    ok-title="Export"
    :ok-disabled="!exportAvailable"
    @show="onModalOpen"
    @ok="processExport"
  >
    <Multiselect
      v-model="selectedLayout"
      :options="layouts"
      :loading="isLoading"
      searchable
      multiple
      :custom-label="customLabel"
      track-by="id"
      class="mb-3"
      placeholder="Export to layout"
      @search-change="searchCustomerLayouts"
      @select="(option) => selectedLayout = [option]"
    >
      <template
        v-if="layouts.length < layoutsTotalCount"
        #afterList
      >
        <div class="load-more-btn">
          <b-button
            :disabled="isLoading"
            variant="outline-primary"
            @click="getLayouts"
          >
            Load More
          </b-button>
        </div>
      </template>
    </Multiselect>
    <b-form-radio-group
      v-model="selectedStrategy"
      name="select-strategy"
      :options="options"
    />
    <SelectTemplateBanner
      v-if="selectedStrategy === IMPORT_INTO_EXISTS_TEMPLATE_STRATEGY"
      v-model="selectedTemplates"
      class="mt-3"
      :customers="customers"
    />
    <b-form-group
      v-if="selectedStrategy === IMPORT_AND_CREATE_STRATEGY"
      class="mt-3"
      label="New layout name"
    >
      <b-form-input
        v-model="layoutName"
      />
    </b-form-group>
  </b-modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import layoutAPI from "@frontend/services/api/layout";
import Customer from "@frontend/services/api/customer";
import SelectTemplateBanner from "@frontend/components/common/atoms/SelectTemplateBanner.vue";
import {
  IMPORT_AND_CREATE_STRATEGY,
  IMPORT_INTO_EXISTS_TEMPLATE_STRATEGY
} from "@frontend/group/modules/import-template-from-psd/import-from-psd-new-template";
let timer;
export default {
  name: 'ExportToLayoutModal',
  components: {
    Multiselect,
    SelectTemplateBanner
  },
  
  data() {
    return {
      customers: [],
      selectedTemplates: {
        customer: null,
        templates: [],
      },
      customerId: null,
      layoutId: null,
      layouts: [],
      layoutName: '',
      imagesToImport: [],
      page: 1,
      searchKey: null,
      layoutsTotalCount: null,
      isLoading: false,
      selectedLayout: [],
      isImporting: false,
      options: [
        { text: 'Create new template', value: IMPORT_AND_CREATE_STRATEGY },
        { text: 'Use existing templates', value: IMPORT_INTO_EXISTS_TEMPLATE_STRATEGY },
      ],
      selectedStrategy: IMPORT_AND_CREATE_STRATEGY
      
    }
  },
  computed: {
    IMPORT_AND_CREATE_STRATEGY() {
      return IMPORT_AND_CREATE_STRATEGY
    },
    IMPORT_INTO_EXISTS_TEMPLATE_STRATEGY() {
      return IMPORT_INTO_EXISTS_TEMPLATE_STRATEGY;
    },
    exportAvailable() {
      switch (this.selectedStrategy) {
        case IMPORT_INTO_EXISTS_TEMPLATE_STRATEGY:
          return (this.layoutName.length || this.selectedLayout.length) && this.selectedTemplates.templates.length
        case IMPORT_AND_CREATE_STRATEGY:
          return this.layoutName.length || this.selectedLayout.length
        default:
          return false
      }
    },
  },
  methods: {
    async onModalOpen() {
      await this.loadCustomers()
      this.page = 1;
      this.searchKey = null;
      this.layouts = [];
      this.selectedLayout = [];
      this.layoutName = '';
      await this.getLayouts();
    },
    async loadCustomers() {
      this.customers = (await Customer.getCustomers()).data
    },
    async getLayouts() {
      this.isLoading = true;

      const {
        data:
          {layouts, totalCount}
      } = await layoutAPI.getLayouts({
        params: {
          search: this.searchKey,
          page: this.page,
          limit: 20
        }
      });

      this.isLoading = false;

      this.layouts = this.layouts.concat(layouts);
      this.layoutsTotalCount = totalCount;
      this.page = this.page += 1;
    },

    customLabel({id, name}) {
      return `${id} - ${name}`;
    },

    searchCustomerLayouts(search) {
      if (timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(() => {
        this.page = 1;
        this.searchKey = search;
        this.layouts = [];

        this.getLayouts();
      }, 500);

    },
    processExport() {
      this.$emit('onExportToLayout', {
        layout: this.selectedLayout[0],
        name: this.layoutName,
        strategy: this.selectedStrategy,
        template_ids: this.selectedTemplates.templates.map(item => item.id),
        customer_id: this.selectedStrategy === IMPORT_AND_CREATE_STRATEGY ? this.selectedLayout[0].customer_id : this.selectedTemplates?.customer?.id,
      });
    },
  }
}
</script>
